import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { FileHandle } from 'src/app/shared/directives/drag-drop.directive';
import { Title } from 'src/app/shared/models/title.model';
import { ValidateImage } from 'src/app/shared/models/validate-image.model';
import { LoadingImagesService } from './loading-images.service';
import { ValidateImagesModalComponent } from './validate-images-modal/validate-images-modal.component';
import * as AWS from 'aws-sdk';
import { DomSanitizer } from '@angular/platform-browser';
import { FileSaverService } from 'ngx-filesaver';
import { AuthUser } from 'src/app/shared/models/auth-user.model';
import { truncate } from 'fs';

@Component({
  selector: 'app-loading-images',
  templateUrl: './loading-images.component.html',
  styleUrls: ['./loading-images.component.scss']
})
export class LoadingImagesComponent implements OnInit {

  files: FileHandle[];
  fileList: File[];
  filterForm: FormGroup;
  modalOptions: NgbModalOptions;
  imageList: ValidateImage[];
  title: Title;
  correctFormat: boolean;
  currentUser: AuthUser;
  // allowLoading: boolean;
  s3Url: string;
  currenDate: Date;
  currentCover = false;
  isSelected: boolean;
  // src = 'https://s3-us-east-2.amazonaws.com/gbibucketdev/230435-BAJA.jpg';
  purposeForm: FormGroup;
  searchTerm: string;
  valo: string;

  private loadingImagesSubscription: Subscription = null;

  constructor(private formBuilder: FormBuilder,
    private loader: NgxSpinnerService,
    private loadingImagesService: LoadingImagesService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private fileSaverService: FileSaverService) {

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg',
    };

  }

  ngOnInit() {
    this.files = [];
    this.fileList = [];
    this.imageList = [];
    this.currenDate = new Date();
    this.valo = 'false';

    this.filterForm = this.formBuilder.group({
      term: [''],
      isbn: [{ value: '', disabled: true }],
      name: [{ value: '', disabled: true }]
    });

    this.purposeForm = this.formBuilder.group({
      is_preview: false,
      portada: false,
      interiores: false
    });

    this.getImages();
  }

  getImages() {

    AWS.config.update({
      accessKeyId: 'AKIAXBAOG3GWFANPH34S', secretAccessKey: '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'
    });

  }

  transform() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.s3Url);
  }

  /**
 * OnDestroy
 */
  ngOnDestroy(): void {
    if (this.loadingImagesSubscription !== null) { this.loadingImagesSubscription.unsubscribe(); }
  }

  filesDropped(files: FileHandle[]): void {
    this.files = files;
  }

  /**
 *
 * @param searchTerm
 */
  onSearchByOracleKey(searchTerm: string) {

    this.searchTerm = searchTerm;

    this.loader.show();

    this.loadingImagesSubscription = this.loadingImagesService.getDataByKey(searchTerm)
      .subscribe((resultOnSearch: Title) => {

        this.loader.hide();

        if (resultOnSearch) {
          this.title = resultOnSearch;

          this.filterForm.patchValue({
            isbn: this.title.isbn,
            name: this.title.title
          });

          // this.allowLoading = true;
        }
        else {
          // this.allowLoading = false;

          this.filterForm.patchValue({
            isbn: "No se encontro información",
            name: "No se encontro información"
          });

          this.toastr.info('No se encontro información relacionada con clave oracle');
        }

      }, (error) => {
        this.loader.hide();
        console.error(error.message);
      });

  }

  validateImages(): void {

    this.imageList = [];

    if (this.files.length !== 0) {

      for (let i in this.files) {

        var archive = new ValidateImage(i);
        archive.name = this.files[i].file.name.toLowerCase();
        archive.format = archive.name.substr(-3);

        if (archive.name.includes('_')) {
          var numberIndex = archive.name.indexOf('_');
        } else {
          var numberIndex = archive.name.indexOf('-');
        }

        var name = archive.name.substr(0, numberIndex);

        // if (name.match("^[0-9]+$")) {

        let val = this.purposeForm.get('portada').value;
        let val2 = this.purposeForm.get('interiores').value;

        if (val == "portadacatual") {
          archive.purpose = 'Portada actual'
        }
        else if (val2 == "interiores") {
          archive.purpose = 'Interiores'
        }
        else {
          switch (archive.format) {
            case 'tif': {
              if (archive.name.includes('4a') || archive.name.includes('4ta')) {
                archive.purpose = 'Contraportada';

                if (archive.name.includes('guia')) {
                  archive.purpose = 'Contraportada guia de profesor'
                }
              }
              /* else if (this.purposeForm.get('is_preview').value === true) {
                archive.purpose = 'Portada actual'
              } */
              else if (archive.name.includes('guia')) {
                archive.purpose = 'Portada guia de profesor'
              } else {
                archive.purpose = 'Portada';
              }
              break;
            }
            case 'jpg': {
              if (archive.name.includes('4a') || archive.name.includes('4ta')) {
                archive.purpose = 'Contraportada';

                if (archive.name.includes('guia')) {
                  archive.purpose = 'Contraportada guia de profesor'
                }
              }
              else if (archive.name.includes('logodelsello')) {
                archive.purpose = 'Logo del sello';
              }
              else if (archive.name.includes('imagenserie')) {
                archive.purpose = 'Serie o colección';
              }
              /* else if (this.purposeForm.get('is_preview').value === true) {
                archive.purpose = 'Portada actual'
              } */
              else if (archive.name.includes('guia')) {
                archive.purpose = 'Portada guia de profesor'
              }
              else {
                archive.purpose = 'Portada';
              }
              break;
            }
            case 'psd': {
              /* if (this.purposeForm.get('is_preview').value === true) {
                archive.purpose = 'Portada actual'
              } */
              if (archive.name.includes('guia')) {
                archive.purpose = 'Portada guia de profesor'
              }
              else {
                archive.purpose = 'Portada';
              }

              break;
            }
            case 'png': {
              archive.purpose = 'Render';
              break;
            }
            case 'pdf': {

              if (archive.name.includes('muestra')) {
                archive.purpose = 'Muestra de lectura';
              }
              else if (archive.name.includes('fichatecnica')) {
                archive.purpose = 'Ficha tecnica';
              }
              else {
                // archive.purpose = 'Interiores';
                archive.purpose = 'portada plana';
              }

              break;
            }
            case 'peg':
              {
                if (archive.name.includes('imagenserie')) {
                  archive.purpose = 'Serie o colección';
                }
                else {
                  archive.purpose = 'Libros del mismo autor';
                }

                break;

              }

          }
        }

        /* switch (archive.format) {
          case 'tif': {
            if (archive.name.includes('4a') || archive.name.includes('4ta')) {
              archive.purpose = 'Contraportada';

              if (archive.name.includes('guia')) {
                archive.purpose = 'Contraportada guia de profesor'
              }
            }
            /* else if (this.purposeForm.get('is_preview').value === true) {
              archive.purpose = 'Portada actual'
            } 
            else if (archive.name.includes('guia')) {
              archive.purpose = 'Portada guia de profesor'
            } else {
              archive.purpose = 'Portada';
            }
            break;
          }
          case 'jpg': {
            if (archive.name.includes('4a') || archive.name.includes('4ta')) {
              archive.purpose = 'Contraportada';

              if (archive.name.includes('guia')) {
                archive.purpose = 'Contraportada guia de profesor'
              }
            }
            else if (archive.name.includes('logodelsello')) {
              archive.purpose = 'Logo del sello';
            }
            else if (archive.name.includes('imagenserie')) {
              archive.purpose = 'Serie o colección';
            }
            /* else if (this.purposeForm.get('is_preview').value === true) {
              archive.purpose = 'Portada actual'
            }
            else if (archive.name.includes('guia')) {
              archive.purpose = 'Portada guia de profesor'
            }
            else {
              archive.purpose = 'Portada';
            }
            break;
          }
          case 'psd': {
            /* if (this.purposeForm.get('is_preview').value === true) {
              archive.purpose = 'Portada actual'
            } 
            if (archive.name.includes('guia')) {
              archive.purpose = 'Portada guia de profesor'
            }
            else {
              archive.purpose = 'Portada';
            }

            break;
          }
          case 'png': {
            archive.purpose = 'Render';
            break;
          }
          case 'pdf': {

            if (archive.name.includes('muestra')) {
              archive.purpose = 'Muestra de lectura';
            }
            else if (archive.name.includes('fichatecnica')) {
              archive.purpose = 'Ficha tecnica';
            }
            else {
              archive.purpose = 'Interiores';
            }

            break;
          }
          case 'peg':
            {
              if (archive.name.includes('imagenserie')) {
                archive.purpose = 'Serie o colección';
              }
              else {
                archive.purpose = 'Libros del mismo autor';
              }

              break;

            }

        } */
        this.imageList.push(archive);
        // }
        // else {
        // this.correctFormat = true;
        // }
      }

      if (this.correctFormat === true) {
        this.toastr.error(`Algun archivo no contiene el formato correcto de nombre`, 'Error');
      }
      else {

        const modalRef = this.modalService.open(ValidateImagesModalComponent, this.modalOptions);
        modalRef.componentInstance.paramList = this.imageList;
        modalRef.componentInstance.paramTitle = this.title;

        modalRef.result.then((result) => {

          this.loader.show();

          for (let i in this.files) {
            this.fileList.push(this.files[i].file);
          }

          this.currentUser = JSON.parse(localStorage.getItem('gbi_auth_user'));

          let val = this.purposeForm.get('portada').value;
          let val2 = this.purposeForm.get('interiores').value;

          let valo = val === false ? val2 : val;

          this.loadingImagesService.uploadImage(this.fileList, this.currentUser.email, result.isbn, result.name, this.searchTerm, valo).subscribe((response: any) => {

            this.files = [];
            this.imageList = [];
            this.fileList = [];
            this.filterForm.reset();
            this.purposeForm.reset();

            this.loader.hide();
            this.toastr.info(`Las imagenes se guardaron correctamente`);

            this.fileSaverService.save(response, 'docGBI' + '_' + name + '_' + this.currenDate.toLocaleDateString() + '.txt');

          }, (error) => {
            console.error(error);
            console.log(error);
            this.fileSaverService.save(error, 'docGBI' + '_' + name + '_' + this.currenDate.toLocaleDateString() + '.txt');
            this.loader.hide();
            this.toastr.error(`Ha ocurrido un error al guardar la imagen, ${error}`, 'Error');
          });


        }, (reason) => { });
      }

    } else {
      this.toastr.error('No se han agregado imágenes', 'Campos Faltantes');
    }
  }

  onCheckboxChange(event) {
    if (event.target.checked) {
      // console.log(event.target.checked);
      this.currentCover = event.target.checked;

      var x = this.purposeForm.get('is_preview').value;
      console.log('valor' + x);


      /*this.checkedList.push(option.images.identifier);
    } else {
      for (let i = 0; i < this.titles.length; i++) {
        if (this.checkedList[i] === option.images.identifier) {
          this.checkedList.splice(i, 1);
        }
      }*/
    }

  }

}

function encode(data) {
  var str = data.reduce(function (a, b) { return a + String.fromCharCode(b) }, '');
  return btoa(str).replace(/.{76}(?=.)/g, '$&\n');
}